/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Metadata Service
 * API for managing interface-specific metadata.
 *
 * The version of the OpenAPI document: 2022-01-26
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *  - AWS_QUICK_LINK: Automated peering using quick-create links.
 *  - AWS_CLOUD_SHELL: Manual peering using AWS CloudShell.
 *  - AWS_WEB_CONSOLE: Manual peering using HCP and AWS web console.
 * @export
 * @enum {string}
 */
export var HashicorpCloudMetadata20220126PeeringConnectionMethod;
(function (HashicorpCloudMetadata20220126PeeringConnectionMethod) {
    HashicorpCloudMetadata20220126PeeringConnectionMethod["QUICKLINK"] = "AWS_QUICK_LINK";
    HashicorpCloudMetadata20220126PeeringConnectionMethod["CLOUDSHELL"] = "AWS_CLOUD_SHELL";
    HashicorpCloudMetadata20220126PeeringConnectionMethod["WEBCONSOLE"] = "AWS_WEB_CONSOLE";
})(HashicorpCloudMetadata20220126PeeringConnectionMethod || (HashicorpCloudMetadata20220126PeeringConnectionMethod = {}));
export function HashicorpCloudMetadata20220126PeeringConnectionMethodFromJSON(json) {
    return HashicorpCloudMetadata20220126PeeringConnectionMethodFromJSONTyped(json, false);
}
export function HashicorpCloudMetadata20220126PeeringConnectionMethodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HashicorpCloudMetadata20220126PeeringConnectionMethodToJSON(value) {
    return value;
}
